import SectionStack from 'components/common/SectionStack'
import { FC, PropsWithChildren } from 'react'

const DefaultLayout: FC<PropsWithChildren> = ({ children }) => {
  return <SectionStack>{children}</SectionStack>
}

export default DefaultLayout
